module.exports = __webpack_public_path__ + "img/pbd_logo.afdf2b2f.png";